

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// ADDREFERRALSSECTIONWITHAPPROVAL
// ADDREFERRALSSECTIONWITHAPPROVAL


const ADDREFERRALSSECTIONWITHAPPROVAL= createAsyncThunk(
  "addReferralSectionWithApproval/addReferralSectionWithApproval",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const addReferralSectionWithApprovalSlice = createSlice({
  name: "addReferralSectionWithApprovalSlice",
  initialState: {
    addReferralSectionWithApproval: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfaddReferralSectionWithApproval: (state) => {
        state.addReferralSectionWithApproval.loading = false
        state.addReferralSectionWithApproval.error = false
        state.addReferralSectionWithApproval.data = []
        state.addReferralSectionWithApproval.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ADDREFERRALSSECTIONWITHAPPROVAL.fulfilled, (state, action) => {
      state.addReferralSectionWithApproval = {
        ...state.addReferralSectionWithApproval,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDREFERRALSSECTIONWITHAPPROVAL.pending, (state, action) => {
      state.addReferralSectionWithApproval = {
        ...state.addReferralSectionWithApproval,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDREFERRALSSECTIONWITHAPPROVAL.rejected, (state, action) => {
      state.addReferralSectionWithApproval = {
        ...state.addReferralSectionWithApproval,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const addReferralSectionWithApprovalAction = {
    ADDREFERRALSSECTIONWITHAPPROVAL,
};

export { addReferralSectionWithApprovalAction };
export default addReferralSectionWithApprovalSlice.reducer;
export const {setInitialStateOfaddReferralSectionWithApproval} = addReferralSectionWithApprovalSlice.actions
